export default "__VITE_ASSET__6c6479d5__"